import React from 'react';
import { XTable } from 'erisxkit/client';

const DEFAULT_PAGE_SIZE = 20;

const ExternalTable = ({
  data,
  metadata,
  onFetchData,
  count,
  loading,
  noDataText,
  pageSize,
  ...rest
}) => (
  <XTable
    loading={loading}
    sortable={false}
    minRows={5}
    noDataText={noDataText}
    className="-striped -highlight"
    columns={metadata}
    data={data}
    onFetchData={onFetchData}
    manual
    pages={Math.ceil(count / (pageSize ?? DEFAULT_PAGE_SIZE))}
    showPageSizeOptions={false}
    defaultPageSize={DEFAULT_PAGE_SIZE}
    pageSize={pageSize ?? DEFAULT_PAGE_SIZE}
    {...rest}
  />
);
export default ExternalTable;
